import { Injectable } from '@angular/core';
import {BasicDialogComponent} from "../../_commons/basic-dialog/basic-dialog.component";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import { BasicAlertComponent } from 'src/app/_commons/basic-alert/basic-alert.component';
import { BasicDialogComponentRefresh } from 'src/app/_commons/basic-dialog/basic-diolog-refresh.component';

@Injectable({
  providedIn: 'root'
})
export class ModalService {
  [x: string]: any;

  constructor(private modalService: NgbModal) { }

  openBasicModal(title: string, content: string){
    let modalRef = this.modalService.open(BasicDialogComponent,
      {
        size: 'lg',
        ariaLabelledBy: 'modal-basic-title',
        centered: false,
        scrollable: true,
        backdrop: 'static'
      });

    (<BasicDialogComponent>modalRef.componentInstance).title = title;
    (<BasicDialogComponent>modalRef.componentInstance).content = content;

    modalRef.result.then(
      (result) => {
      },
      (reason) => {
      }
    );
  }

  openBasicModalRefresh(title: string, content: string){
    let modalRef = this.modalService.open(BasicDialogComponentRefresh,
      {
        size: 'lg',
        ariaLabelledBy: 'modal-basic-title',
        centered: false,
        scrollable: true,
        backdrop: 'static'
      });

    (<BasicDialogComponent>modalRef.componentInstance).title = title;
    (<BasicDialogComponent>modalRef.componentInstance).content = content;

    modalRef.result.then(
      (result) => {
      },
      (reason) => {
      }
    );
  }

  openBasicAlert(title: string, content: string){
    let modalRef = this.modalService.open(BasicAlertComponent,
      {
        size: 'lg',
        ariaLabelledBy: 'modal-basic-title',
        centered: false,
        scrollable: true,
        backdrop: 'static'
      });

    (<BasicAlertComponent>modalRef.componentInstance).title = title;
    (<BasicAlertComponent>modalRef.componentInstance).content = content;

    modalRef.result.then(
      (result) => {
      },
      (reason) => {
      }
    );
  }

  openBasicConfirmation(title: string, content: string){
    let modalRef = this.modalService.open(BasicAlertComponent,
      {
        size: 'lg',
        ariaLabelledBy: 'modal-basic-title',
        centered: false,
        scrollable: true,
        backdrop: 'static'
      });

    (<BasicAlertComponent>modalRef.componentInstance).title = title;
    (<BasicAlertComponent>modalRef.componentInstance).content = content;

    modalRef.result.then(
      (result) => {
      },
      (reason) => {
      }
    );
  }
}
